import React, { useState } from 'react'
import SidebarElement from './SidebarElement'
const AdminSidebarContent = () => {
  const [nodes] = useState([
    {
      key: '1',
      label: 'Dashboard',
      link: '/admin',
      icon: 'mdi mdi-home',
    },
    {
      key: '3',
      label: 'Orders',
      link: '/admin/orders',
      icon: 'mdi mdi-file-document-multiple',
    },
    {
      key: '4',
      label: 'Reports',
      link: '/#',
      icon: 'mdi mdi-text-box-multiple',
      children: [
        {
          key: '4-0',
          label: 'Manufacturers',
          link: '/admin/reports/manufacturers',
          icon: 'mdi mdi-factory',
        },
        {
          key: '4-1',
          label: 'Molecules',
          link: '/admin/reports/molecules',
          icon: 'mdi mdi-chemical-weapon',
        },
        {
          key: '4-2',
          label: 'Pay Statements',
          link: '/admin/reports/paPayments',
          icon: 'mdi mdi-cash-multiple',
        },
        {
          key: '4-3',
          label: 'PA Payables',
          link: '/admin/reports/paPayables',
          icon: 'mdi mdi-chemical-weapon',
        },
        {
          key: '4-4',
          label: 'PA Payables per Orders',
          link: '/admin/reports/paPayables/orders',
          icon: 'mdi mdi-chemical-weapon',
        },
      ],
    },
    {
      key: '5',
      label: 'Catalogue',
      link: '/#',
      icon: 'mdi mdi-book-open',
      children: [
        {
          key: '5-1',
          label: 'Import Catalogue',
          link: '/admin/catalogue/import',
          icon: 'mdi mdi-upload',
        },
        {
          key: '5-2',
          label: 'Manage catalogue',
          link: '/admin/catalogue/manage',
          icon: 'mdi mdi-table-large',
        },
      ],
    },
    {
      key: '6',
      label: 'Settings',
      link: '/#',
      icon: 'mdi mdi-cog',
      children: [
        {
          key: '6-0',
          label: 'Pharmacies',
          link: '/admin/pharmacies',
          icon: 'mdi mdi-pharmacy',
        },
        {
          key: '6-1',
          label: 'Manufacturers',
          link: '/admin/manufacturers',
          icon: 'mdi mdi-chemical-weapon',
        },
        {
          key: '6-2',
          label: 'Manufacturers Users',
          link: '/admin/manufacturers-users',
          icon: 'mdi mdi-chemical-weapon',
        },
        {
          key: '6-3',
          label: 'Administrators',
          link: '/admin/admins-list',
          icon: 'mdi mdi-account-group',
        },
        {
          key: '6-4',
          label: 'Molecules',
          link: '/admin/molecules',
          icon: 'mdi mdi-chemical-weapon',
        },
        {
          key: '6-5',
          label: 'Ads',
          link: '/admin/ads-control-panel',
          icon: 'mdi mdi-chemical-weapon',
        },
        {
          key: '6-6',
          label: 'Pharmacy Groups',
          link: '/admin/pharmacy-groups',
          icon: 'mdi mdi-account-group',
        },
      ],
    },
    {
      key: '7',
      label: 'PA Navigator',
      link: '/admin/recommendations',
      icon: 'mdi mdi-lightbulb-on',
    },
    {
      key: '8',
      label: 'Upload File',
      link: '/admin/upload-file',
      icon: 'mdi mdi-upload',
    },
    {
      key: '2',
      label: 'Profile',
      link: '/admin/profile',
      icon: 'mdi mdi-account',
    },
    {
      key: '9',
      label: 'Logout',
      link: 'logout',
      icon: 'mdi mdi-logout',
    },
  ])

  return (
    <>
      {nodes.map((menuItem) => (
        <SidebarElement
          key={menuItem.key}
          name={menuItem.label}
          link={menuItem.link}
          iconClass={menuItem.icon}
          notifications={menuItem.notifications}
          children={menuItem.children}
        />
      ))}
    </>
  )
}

export default AdminSidebarContent
